/**
 * Constants for AdminResources - Programs, Libraries, Resource Types
 */
import { 
  Sparkles, 
  Flame, 
  Compass, 
  Target, 
  BookOpen 
} from "lucide-react";

// Program options (maps to courses)
export const PROGRAMS = [
  { value: "wake_up", label: "Wake Up", icon: Sparkles, color: "#f59e0b" },
  { value: "burn_the_map", label: "Burn the Map", icon: Flame, color: "#ef4444" },
  { value: "whole", label: "Whole", icon: Compass, color: "#10b981" },
  { value: "purposeful_paths", label: "Purposeful Paths", icon: Target, color: "#3b82f6" },
  { value: "reference", label: "Reference", icon: BookOpen, color: "#8b5cf6" },
];

// Library/Chamber options
export const LIBRARIES = [
  { value: "wake_up_library", label: "Wake Up Library", program: "wake_up" },
  { value: "burn_the_map_library", label: "Burn the Map Library", program: "burn_the_map" },
  { value: "whole_library", label: "Whole Library", program: "whole" },
  { value: "purposeful_paths_library", label: "Purposeful Paths Library", program: "purposeful_paths" },
  { value: "reference_library", label: "Reference Library", program: "reference" },
];

export const RESOURCE_TYPES = [
  { value: "pdf", label: "PDF Document" },
  { value: "worksheet", label: "Worksheet" },
  { value: "guide", label: "Guide" },
  { value: "template", label: "Template" },
  { value: "audio", label: "Audio" },
  { value: "video", label: "Video" },
];

// Initial form state
export const INITIAL_FORM = {
  file: null,
  title: "",
  description: "",
  resource_type: "pdf",
  vault_chamber: "",
  program: "",
  module_id: "",
  lesson_id: "",
  tags: "",
};

// Utility functions
export const getProgramInfo = (program) => {
  return PROGRAMS.find(p => p.value === program) || null;
};

export const getLibraryLabel = (chamberId) => {
  return LIBRARIES.find(l => l.value === chamberId)?.label || chamberId || "—";
};

export const formatFileSize = (bytes) => {
  if (!bytes) return "—";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};
